// Generated by ts-to-zod
import { z } from 'zod';
import {
  CreatedByRole,
  ReporterEnum,
  TicketSortField,
  SortOrder,
  TicketStatus,
  ListTicketsParams1ReporterEnum,
} from './help-hub-api';

export const attachmentFileResponseSchema = z.object({
  name: z.string(),
  size: z.int32(),
  thumbnail: z.string().optional().nullable(),
});

export const userSchema = z.object({
  fullname: z.string().optional().nullable(),
  id: z.string(),
});

export const createdByRoleSchema = z.enum(CreatedByRole);

export const attachmentResponseSchema = z.object({
  created_by: userSchema,
  file: attachmentFileResponseSchema.optional().nullable(),
  id: z.string(),
  respondent_group: z.string(),
  role: createdByRoleSchema,
  ticket_id: z.string(),
  uploaded_at: z.string().datetime(),
});

export const catalogFieldReferenceResponseSchema = z.object({
  isRequired: z.boolean().optional().nullable(),
  key: z.string(),
  label: z.string().optional().nullable(),
  options: z.array(z.string()).optional().nullable(),
  placeholder: z.string().optional().nullable(),
});

export const catalogNudgeResponseSchema = z.object({
  isRequired: z.boolean(),
  text: z.string(),
  title: z.string().optional().nullable(),
});

export const catalogSupportChannelResponseSchema = z.object({
  email: z.string().optional().nullable(),
  phoneNumber: z.string().optional().nullable(),
  serviceName: z.string().optional().nullable(),
  type: z.string(),
  url: z.string().optional().nullable(),
});

export const catalogCategoryResponseSchema = z.object({
  canEscalate: z.boolean(),
  description: z.string(),
  fields: z.array(catalogFieldReferenceResponseSchema),
  isFeedback: z.boolean().optional().nullable(),
  key: z.string(),
  nudge: catalogNudgeResponseSchema.optional().nullable(),
  supportChannel: catalogSupportChannelResponseSchema,
  title: z.string(),
});

export const catalogFieldValidationResponseSchema = z.object({
  maxLength: z.int32().optional().nullable(),
  minLength: z.int32().optional().nullable(),
});

export const catalogFieldDefinitionResponseSchema = z.object({
  inputType: z.string().optional().nullable(),
  isMulti: z.boolean(),
  isRequired: z.boolean(),
  label: z.string(),
  options: z.array(z.string()),
  placeholder: z.string().optional().nullable(),
  providerKey: z.string(),
  type: z.string(),
  useHelixField: z.boolean(),
  validation: catalogFieldValidationResponseSchema.optional().nullable(),
});

export const commentResponseSchema = z.object({
  attachments: z.array(attachmentResponseSchema),
  created_by: userSchema,
  id: z.string(),
  respondent_group: z.string(),
  role: createdByRoleSchema,
  submit_date: z.string().datetime(),
  text: z.string(),
  type: z.string(),
  view_access: z.string().optional().nullable(),
});

export const commentsResponseSchema = z.object({
  data: z.array(commentResponseSchema),
});

export const createAttachmentParamsSchema = z.object({
  ticketId: z.string(),
});

export const createCommentParamsSchema = z.object({
  ticketId: z.string(),
});

export const customFieldDtoSchema = z.union([
  z.string(),
  z.array(z.string()),
  z.number(),
  z.array(z.number()),
  z.boolean(),
]);

export const downloadAttachmentParamsSchema = z.object({
  attachmentId: z.string(),
  ticketId: z.string(),
});

export const getAttachmentsParamsSchema = z.object({
  ticketId: z.string(),
});

export const getCommentsParamsSchema = z.object({
  ticketId: z.string(),
});

export const getTicketParamsSchema = z.object({
  ticketId: z.string(),
});

export const reporterEnumSchema = z.enum(ReporterEnum);

export const ticketSortFieldSchema = z.enum(TicketSortField);

export const sortOrderSchema = z.enum(SortOrder);

export const ticketStatusSchema = z.enum(TicketStatus);

export const listTicketsParams1ReporterEnumSchema = z.enum(
  ListTicketsParams1ReporterEnum
);

export const slaResponseSchema = z.object({
  due_date: z.string().datetime(),
  expired: z.boolean(),
  id: z.string(),
});

export const ticketListMetaSchema = z.object({
  total: z.int32(),
});

export const ticketResponseSchema = z.object({
  area: z.string().optional().nullable(),
  category: z.string().optional().nullable(),
  created_at: z.string().datetime(),
  created_by: userSchema,
  custom_fields: z.record(z.string(), customFieldDtoSchema),
  department: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  escalated: z.boolean().optional().nullable(),
  id: z.string(),
  is_feedback: z.boolean().optional().default(false),
  resolution_note: z.string().optional().nullable(),
  slas: z.array(slaResponseSchema),
  status: ticketStatusSchema,
  store_id: z.string().optional().nullable(),
  subject: z.string(),
});

export const unitSchema = z.record(z.string(), z.any());

export const attachmentsResponseSchema = z.object({
  data: z.array(attachmentResponseSchema),
});

export const catalogDepartmentResponseSchema = z.object({
  canEscalate: z.boolean().optional().nullable(),
  categories: z.array(catalogCategoryResponseSchema),
  description: z.string().optional().nullable(),
  fields: z.array(catalogFieldReferenceResponseSchema),
  isFeedback: z.boolean().optional().nullable(),
  key: z.string(),
  nudge: catalogNudgeResponseSchema.optional().nullable(),
  supportChannel: catalogSupportChannelResponseSchema.optional().nullable(),
  title: z.string(),
});

export const catalogAreaResponseSchema = z.object({
  departments: z.array(catalogDepartmentResponseSchema),
  description: z.string().optional().nullable(),
  key: z.string(),
  title: z.string(),
});

export const createTicketRequestSchema = z.object({
  area: z.string(),
  catalog_version: z.string().optional().nullable(),
  category: z.string().optional().nullable(),
  custom_fields: z
    .record(z.string(), customFieldDtoSchema)
    .optional()
    .nullable(),
  department: z.string(),
  description: z
    .string()
    .min(20, 'description must be at least 20 characters')
    .max(2000, 'description must be at most 2000 characters'),
  escalated: z.boolean().optional().nullable(),
  is_feedback: z.boolean().optional().nullable(),
  store_id: z.int64(),
  subject: z
    .string()
    .min(1, 'subject must be at least 1 character')
    .max(200, 'subject must be at most 200 characters'),
});

export const listTicketsParamsSchema = z.object({
  area: z.string().optional().nullable(),
  category: z.string().optional().nullable(),
  department: z.string().optional().nullable(),
  page: z.int32().optional().default(1),
  per_page: z.int32().optional().default(10),
  reporter: reporterEnumSchema.optional().nullable(),
  search: z.string().optional().nullable(),
  sort_by: ticketSortFieldSchema.optional().nullable(),
  sort_order: sortOrderSchema.optional().nullable(),
  status: ticketStatusSchema.optional().nullable(),
  store_id: z.int64(),
});

export const ticketListResponseSchema = z.object({
  data: z.array(ticketResponseSchema),
  meta: ticketListMetaSchema,
});

export const catalogResponseSchema = z.object({
  areas: z.array(catalogAreaResponseSchema),
  fields: z.record(z.string(), catalogFieldDefinitionResponseSchema),
  version: z.string(),
});
